import { Paper } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
    approveClaimMsg,
    approveLeaveMsg,
    cancelBillMsg,
    noInternetMsg,
    rejectClaimMsg,
    rejectLeaveMsg,
    savemsg,
    serverMsg,
    statusmsg,
} from "../../config/messageconstant";
import { SalesTeamLeaveJson } from "../../DynamicFormsJson/MastersJSON/salesTeamLeaveJson";
import {
    SalesTeamLeaveColumns
} from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { getLeaveForAuthorityPersonByDates } from "../../Slice/LeaveType.slice";
import SalesTeamLeaveViewPopUp from "./SalesTeamLeaveViewPopUp";
import { getCurrentDate } from "../../utils/dateFormat";

class SalesTeamLeaveTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            viewDataList: [],
            viewPopup: false,
            DataToSet: [],
            viewData: {},
            onSearchData: {},
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        const { getLeaveForAuthorityPersonByDates, showLoador, showNotification } = this.props;

        if (navigator.onLine) {
            const currentDate = getCurrentDate();
            showLoador({ loador: true });
            await getLeaveForAuthorityPersonByDates({ fromDate: currentDate, toDate: currentDate }).then(({ response, success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" });
                } else {
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }

    }

    rowViewData = (rowData) => {
        const { showLoador, showNotification } = this.props;
        showLoador({ loador: true });
        apiGet({
            url: endpoint.leaveApply + "/" + rowData.id,
        }).then(({ data, success }) => {
            console.log(data)
            showLoador({ loador: false });
            if (success) {
                this.setState({
                    viewData: data.data,
                    DataToSet: [
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "Leave Type",
                            value: data.data.leaveType !== null &&
                                data.data.leaveType.name !== null ? data.data.leaveType.name : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "No. Of Days",
                            value: data.data.noOfDays !== null ? data.data.noOfDays : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "Status",
                            value: data.data.status !== null ?
                                data.data.status == 0 ? "Pending" :
                                    data.data.status == 2 ? "Approved" :
                                        data.data.status == 3 ? "Rejected" : "-" : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "Subject",
                            value: data.data.leaveReason !== null ? data.data.leaveReason : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "Start Date",
                            value: data.data.fromDate !== null ? data.data.fromDate : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "End Date",
                            value: data.data.toDate !== null ? data.data.toDate : "-",
                        },
                        {
                            xs: 12,
                            sm: 6,
                            md: 6,
                            lg: 6,
                            label: "Description",
                            value: data.data.description !== null ? data.data.description : "-",
                        },
                    ],
                    viewPopup: true,
                });
            }

        });
    }

    rowCancel = (rowData) => {
        const { showLoador, showNotification } = this.props;
        swal({
            title: "Are you sure?",
            text: rejectLeaveMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                const statusCode = 3;
                apiGet({
                    url:
                        endpoint.leaveApply +
                        "/update-status?leaveApplyId=" +
                        rowData.id +
                        "&status=" +
                        statusCode,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        this.props.showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({ msg: statusmsg });
                        this.onSearchData(this.state.onSearchData);
                    }
                });
            }
        });
    };

    rowApply = (rowData) => {
        const { showLoador, showNotification } = this.props;
        swal({
            title: "Are you sure?",
            text: approveLeaveMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                const statusCode = 2;
                apiGet({
                    url:
                        endpoint.leaveApply +
                        "/update-status?leaveApplyId=" +
                        rowData.id +
                        "&status=" +
                        statusCode,
                }).then(({ data, success }) => {
                    showLoador({ loador: false });
                    if (!success) {
                        this.props.showNotification({
                            msg: serverMsg,
                            severity: "error",
                        });
                    } else {
                        showNotification({ msg: statusmsg });
                        this.onSearchData(this.state.onSearchData);
                    }
                });
            }
        });
    };

    handleClosesCategory = () => {
        this.setState({
            viewPopup: false,
        });
    };

    onSearchData = async (data) => {
        const { getLeaveForAuthorityPersonByDates, showLoador, showNotification } = this.props;

        if (navigator.onLine) {

            this.setState({
                onSearchData: data,
            });

            const currentDate = getCurrentDate();

            showLoador({ loador: true });
            await getLeaveForAuthorityPersonByDates({
                fromDate: data?.fromDate ?? currentDate,
                toDate: data?.toDate ?? currentDate
            }).then(({ response, success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error" })
                } else {
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    render() {
        const {
            SalesClaimList,
            ClaimList,
            beatList,
            leaveList,
            getLeaveForAuthorityPersonByDates,
        } = this.props;
        const {
            viewPopup,
            DataToSet,
            viewDataList,
            viewData,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <DynamicMainScreen
                        searchList={SalesTeamLeaveJson.searchListForAdmin}
                        onSearchData={this.onSearchData}
                        formPath={SalesTeamLeaveJson.formPath}
                        screenTitle={SalesTeamLeaveJson.screenTitle}
                        fieldMeta={SalesTeamLeaveJson.fieldMeta}
                        showPdfDownload={SalesTeamLeaveJson.showPdfDownload}
                        showExtension={false}
                        pdfFileName={SalesTeamLeaveJson.pdfFileName}
                        excelFileName={SalesTeamLeaveJson.excelFileName}
                        showAddButton={SalesTeamLeaveJson.showAddButton}
                        tableColumnsToFilter={SalesTeamLeaveJson.tableColumnsToFilter}
                        tableColumns={SalesTeamLeaveColumns}
                        tableData={leaveList?.leaveForAuthorityPerson}
                        showExcelDownload={true}
                        filterDataExcel={true}
                        getTableData={this.onSearchData}
                        apiBaseURL={SalesTeamLeaveJson.apiBaseURL}
                        baseIdColumn={SalesTeamLeaveJson.baseIdColumn}
                        showEditIcon={false}
                        showDeleteIcon={false}
                        showViewButtonInTable={true}
                        staticView={true}
                        rowView={this.rowViewData}
                        showCancel={true}
                        rowCancel={this.rowCancel}
                        showCancelTitle={"Reject Leave"}
                        showApply={true}
                        showApplyTitle={"Approve Leave"}
                        rowApply={this.rowApply}
                        //comment by tejas for condition
                        // cancelBillConditionName="status"
                        // cancelBillConditionValue="0"
                        credentialConditionName="status"
                        credentialConditionValue="0"
                        callApi={false}
                        getTableDataById={true}
                    />
                </Paper>
                {viewPopup && (
                    <SalesTeamLeaveViewPopUp
                        open={viewPopup}
                        handleCloses={this.handleClosesCategory}
                        DataToSet={DataToSet}
                        viewData={viewData}
                    />
                )}
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    leaveList: state.leaveType,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getLeaveForAuthorityPersonByDates,
};
export default connect(mapStateToProps, mapDispatchToProps)(SalesTeamLeaveTable);